import { Link, Navigate, useLocation } from 'react-router-dom';
import { RequestType } from './quoteInquiryService';
import styles from './QuoteComplete.module.scss';

interface QuoteCompleteState {
  orderNo?: string;
  requestType?: RequestType;
}

function QuoteComplete() {
  const location = useLocation();
  const state = (location.state as QuoteCompleteState | null) ?? null;

  if (!state?.orderNo) {
    return <Navigate to="/quote" replace />;
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <h1 className={styles.title}>제출되었습니다</h1>
        <p className={styles.desc}>
          {state.requestType === 'ORDER' ? '주문서가' : '견적문의가'} 정상적으로 접수되었습니다.
          <br />
          담당자가 확인 후 연락처 및 이메일로 답변드립니다.
          <br />
          금액이 확정되면 주문조회에서 견적서를 내려받으실 수 있습니다.
        </p>
        <div className={styles.orderNo}>
          접수번호 <strong>{state.orderNo}</strong>
        </div>
        <div className={styles.actions}>
          <Link to="/" className={styles.btn}>
            홈으로
          </Link>
          <Link to="/lookup" className={`${styles.btn} ${styles.primary}`}>
            주문조회
          </Link>
        </div>
      </div>
    </div>
  );
}

export default QuoteComplete;
